import React from "react";

function SellerTermsAndConditions() {
  return (
    <>
      <div className="container">
        <div className="row">
          <div
            className="col-12"
            style={{
              width: "93%",
              position: "fixed",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div id="loading" style={{ display: "none" }}></div>
          </div>
        </div>
      </div>

      <div
        className="container for-container rtl"
        style={{ textAlign: "left" }}
      >
        <h2 className="text-center mt-3 headerTitle">Terms and Conditions</h2>
        <div className="for-padding">
          <h1>A. Introduction:</h1>
          <p>
            Welcome to Zambet additionally thusly known as "we", "us" or "
            Zambet". We are an online commercial center and these are the terms
            and conditions overseeing your entrance and utilization of Zambet
            alongside its related sub-areas, destinations, portable application,
            administrations and apparatuses (the "Website"). By utilizing the
            Site, you thusly acknowledge these terms and conditions (counting
            the connected data in this) and speak to that you consent to conform
            to these terms and conditions (the "Client Agreement"). This User
            Agreement is regarded as successful upon your utilization of the
            Site which means your acknowledgment of these terms. On the off
            chance that you don't consent to be bound by this User Agreement
            kindly don't get to, register with or utilize this Site. This Site
            is claimed and worked by Zambet India Limited, an organization
            consolidated under the Companies Act, 1994.
          </p>
          <p>
            The Site maintains whatever authority is needed to change, adjust,
            include, or expel bits of these Terms and Conditions whenever with
            no earlier warning. Changes will be successful when posted on the
            Site with no other notification gave. If it's not too much trouble
            check these Terms and Conditions normally for refreshes. You proceed
            with the utilization of the Site following the presenting of changes
            on Terms and Conditions of utilization establishes your
            acknowledgment of those changes.
          </p>
          <p>B. CONDITIONS OF USE</p>
          <p>1. YOUR ACCOUNT</p>
          <p>
            To get to specific administrations offered by the stage, we may
            necessitate that you make a record with us or give individual data
            to finish the making of a record. We may whenever in our sole and
            total watchfulness, nullify the username as well as password without
            giving any explanation or earlier notice and will not be at risk or
            answerable for any misfortunes endured by, brought about by,
            emerging out of, regarding or by reason of such solicitation or
            negation.
          </p>
          <p>
            Any agreement between us, regardless of whether for utilization of
            the site or in connection to the buy of items or administrations
            through the site will be represented by the laws of India and all
            gatherings submit to the non-restrictive purview of the India
            Courts.
          </p>
          <p>
            You are answerable for keeping up the classification of your client
            recognizable proof, password, account subtleties, and related
            private data. You consent to acknowledge this obligation and
            guarantee your record and its related subtleties are kept up safely
            consistently and every essential advance is taken to avoid abuse of
            your record. You ought to advise us promptly on the off chance that
            you have any motivation to accept that your secret phrase has gotten
            known to any other individual, or if the secret word is being, or is
            probably going to be, utilized in an unapproved way. You concur and
            recognize that any utilization of the Site and related
            administrations offered as well as any entrance to private data,
            information or interchanges utilizing your record and secret word
            will be esteemed to be either performed by you or approved by you
            all things considered. You consent to be bound by any entrance of
            the Site as well as utilization of any administrations offered by
            the Site (regardless of whether such access or use are approved by
            you or not). You concur that we will be entitled (yet not obliged)
            to follow up on, depend on or consider you exclusively capable and
            subject in regard thereof as though the equivalent were done or
            transmitted by you. You further concur and recognize that you will
            be bound by and consent to completely reimburse us against all
            misfortunes emerging from the utilization of or access to the Site
            through your record.
          </p>
          <p>
            It would be ideal if you guarantee that the subtleties you give us
            are right and finish consistently. You are committed to refreshing
            insights regarding your record progressively by getting to your
            record on the web. For snippets of data you are not ready to refresh
            by getting to Your Account on the Site, you should advise us by
            means of our client care correspondence channels to help you with
            these changes. We claim all authority to decline access to the Site,
            end records, evacuate or alter content whenever without earlier
            notice to you. We may whenever in our sole and total carefulness,
            demand that you update your Personal Data or forthwith negate the
            record or related subtleties without giving any explanation or
            earlier notice and will not be at risk or liability for any
            misfortunes endured by or brought about by you or emerging out of or
            regarding or by reason of such solicitation or nullification. You
            thusly consent to change your secret key now and again and to keep
            your record secure and furthermore will be answerable for the
            privacy of your record and obligated for any revelation or use
            (regardless of whether such use is approved or not) of the username
            and additionally secret key.
          </p>
          <p>2. Your account vs your order</p>
          <p>
            We Only Consider the name of an Zambet account holder as the owner
            of and the client of the product(s) which has been ordered from the
            respective Zambet account. You should not request for any changes in
            the name of the owner while delivering the product (i.e.: Motor
            Bike/Car, apartments, lands etc.)
          </p>
          <p>
            Zambet&nbsp;retains all kinds of authority to
            ban/cancel/freeze/unfreeze your account(s) if they think it should
            be done so. Zambet is not bound to provide the balance amount (of
            cashback)to you if your account is blocked/banned. Any kind of
            balance paid by you through bkash/bank/cash would be refunded to you
            within a reasonable time period. Please note that it may depend on
            the calculation of your total payment vs the cashback you received
            and used.
          </p>
          <p>3. Your Conduct:</p>
          <p>
            You should not utilize the site at all that causes, or is probably
            going to cause, the Site or access to it to interfere, harmed or
            disabled in any capacity. You should not participate in exercises
            that could hurt or conceivably hurt the Site, its workers,
            officials, delegates, partners or some other gathering legitimately
            or in a roundabout way connected with the Site or access to it to be
            intruded, harmed or debilitated in any capacity. You comprehend that
            you, and not us, are answerable for every single electronic
            correspondence and substance sent from your PC to us and you should
            utilize the Site for legal purposes as it were. You are carefully
            restricted from utilizing the Site
          </p>
          <p>
            Zambet&nbsp;might not be subject to any individual for any
            misfortune or harm, which may emerge from the utilization of any of
            the data contained in any of the materials on this site.
          </p>
          <ul>
            <li>
              for deceitful purposes, or regarding a criminal offense or other
              unlawful movements
            </li>
            <li>
              to send, utilize or reuse any material that doesn't have a place
              with you; or is illicit, hostile (counting yet not constrained to
              material that is explicitly unequivocal substance or which
              advances prejudice, dogmatism, scorn or physical mischief),
              tricky, misdirecting, damaging, foul, hassling, disrespectful,
              abusive, derogatory, vulgar, obscene, pedophilic or threatening;
              ethically questionable, stigmatizing or in break of copyright,
              trademark, secrecy, protection or some other exclusive data or
              right; or is generally damaging to outsiders; or identifies with
              or advances tax evasion or betting; or is unsafe to minors in any
              capacity; or mimics someone else; or undermines the solidarity,
              trustworthiness, security or power of India or neighborly
              relations with remote States; or offensive or generally unlawful
              in any way at all; or which comprises of or contains programming
              infections, political battling, business sales, networking
              letters, mass mailings or any ‘spam‘
            </li>
            <li>Use the Site for illicit purposes.</li>
            <li>to cause irritation, bother or unnecessary nervousness</li>
            <li>
              for whatever other purposes that is other than what is expected by
              us
            </li>
          </ul>
          <p>4. Submission:</p>
          <p>
            Anything that you submit to the Site or potentially give to us,
            including yet not restricted to, questions, audits, remarks, and
            proposals (on the whole, "Entries") will turn into our sole and
            selective property and will not become back to you. Notwithstanding
            the rights pertinent to any Submission, when you present remarks or
            surveys on the Site, you additionally award us the privilege to
            utilize the name that you submit, regarding such audit, remark, or
            other substance. You will not utilize a bogus email address, profess
            to be somebody other than yourself or generally misdirect us or
            outsiders with regards to the cause of any Submissions. We may, yet
            will not be committed to, expel or alter any Submissions with no
            notification or lawful course appropriate to us in such manner.
          </p>
          <p>5. CLAIMS AGAINST OBJECTIONABLE CONTENT:</p>
          <p>
            We list a huge number of items including apartments &amp; Lands
            available to be purchased offered by various dealers on the Site and
            host different remarks on postings, it isn't workable for us to know
            about the substance of every item recorded available to be purchased
            or each remark or survey that is shown. Appropriately, we work on a
            "guarantee, audit and takedown" premise. On the off chance that you
            accept that any substance on the Site is illicit, hostile (counting
            yet not restricted to material that is explicitly express substance
            or which advances prejudice, bias, scorn or physical mischief),
            beguiling, deluding, harsh, profane, irritating, impious,
            slanderous, offensive, revolting, obscene, pedophilic or
            threatening; ethnically questionable, criticizing; or is generally
            damaging to outsiders; or identifies with or advances tax evasion or
            betting; or isdestructive to minors in any capacity; or mimics
            someone else; or compromises the solidarity, trustworthiness,
            security or sway of India or cordial relations with remoteStates; or
            shocking or generally unlawful in any way at all; or which comprises
            of or contains programming infections, (" frightful substance "),
            please tell us quickly by following by keeping in touch with us on
            legal@ Zambet.com. We will make every single useful undertaking to
            examine and evacuate substantial offensive substance griped about
            inside a sensible measure of time.
          </p>
          <p>
            If it's not too much trouble guarantee to give your name, address,
            contact data and the same number of pertinent subtleties of the case
            including the name of frightful substance party, occasions of
            protest, confirmation of complaint among others. If you don't mind
            note that giving inadequate subtleties will ruin your case and
            unusable for legitimate purposes.
          </p>
          <p>6. CLAIMS AGAINST INFRINGING CONTENT:</p>
          <p>
            We regard the licensed innovation of others. On the off chance that
            you accept that your licensed innovation rights have been utilized
            such that offers to ascend to worries of encroachment if it's not
            too much trouble illuminate us and we will endeavor every single
            sensible exertion to address your worry inside a sensible measure of
            time. It would be ideal if you guarantee to give your name, address,
            contact data and the same number of pertinent subtleties of the case
            including the name of encroaching gathering, cases of encroachment,
            and verification of encroachment among others. If you don't mind
            note that giving deficient subtleties will ruin your case and
            unusable for lawful purposes. What's more, giving bogus or
            misdirecting data might be viewed as a legitimate offense and might
            be trailed by lawful procedures.
          </p>
          <p>
            We likewise regard a maker's entitlement to go into selective
            appropriation or resale understandings for its items. In any case,
            infringement of such understandings doesn’t establish licensed
            innovation rights encroachment. As the implementation of these
            understandings is an issue between the producer, wholesaler and
            additionally particular affiliate, it would not be befitting for us
            to aid the authorization of such exercises. While we can't give
            legitimate guidance, nor share private data as secured by the law,
            we suggest that any inquiries or concerns with respect to your
            privileges might be steered to lawful authority.
          </p>
          <p>7. Indemnity</p>
          <p>
            You will repay and hold innocuous Zambet Limited, its auxiliaries,
            offshoots, and their particular officials, executives, operators,
            and representatives, from any case or request, or activities
            including sensible lawyer's expenses, made by any outsider or
            punishment forced due to or emerging out of your break of these
            Terms and Conditions or any record joined by reference, or your
            infringement of any law, rules, guidelines or the privileges of an
            outsider.
          </p>
          <p>
            You therefore explicitly discharge Zambet as possessed by offshoots
            as well as any of its officials and delegates from any cost, harm,
            obligation or other outcome of any of the activities/inactions of
            the merchants or other specialist co-ops and explicitly waiver any
            cases or requests that you may have for this benefit under any
            resolution, contract or something else.
          </p>
          <p>8. Losses</p>
          <p>
            We won't be answerable for any business or individual misfortunes
            (counting however not restricted to loss of benefits, income,
            contracts, foreseen investment funds, information, altruism, or
            squandered consumption) or whatever other backhanded or weighty
            misfortune that isn't sensibly predictable to both you and us when
            you initiated utilizing the Site.
          </p>
          <p>
            9. Corrections TO CONDITIONS OR ALTERATIONS OF SERVICE AND RELATED
            PROMISE
          </p>
          <p>
            We maintain all authority to make changes to the Site, its
            strategies, these terms and conditions and some other freely showed
            condition or administration guarantee whenever. You will be
            dependent upon the approaches and terms and conditions in power at
            the time you utilized the Site except if any change to those
            strategies or these conditions is required to be made by law or
            government expert (in which case it will apply to orders recently
            set by you). In the event that any of these conditions is regarded
            invalid, void, or in any way, shape or form unenforceable, that
            condition will be considered severable and won't influence the
            legitimacy and enforceability of any outstanding condition.
          </p>
          <p>10. WAIVER</p>
          <p>
            You recognize and perceive that we are a private business endeavor
            and claim all authority to lead the business to accomplish our
            targets in a way we esteem fit. You additionally recognize that in
            the event that you break the conditions expressed on our Site and we
            make no move, we are as yet qualified for utilizing our privileges
            and cures in whatever other circumstance where you rupture these
            conditions.
          </p>
          <p>11. Administering LAW AND JURISDICTION</p>
          <p>
            These terms and conditions are administered by and interpreted as
            per the laws of The People's Republic of India. You concur that the
            courts, councils and additionally semi-legal bodies situated in
            Dhaka, India will have the restrictive purview on any question
            emerging inside India under this Agreement.
          </p>
          <p>12. Offers:</p>
          <p>
            Zambet&nbsp;is not liable or bound to provide any other offers of
            any merchant/importer/ vendors’ at any other places/sites except
            Zambet. You can just request/ask/solicitation or look for data about
            the offers given/declared by Zambet.
          </p>
          <p>
            One client will have the option to buy one item during any special
            offers (*if not allowed and announced multiple quantities by
            Zambet).
          </p>
          <p>
            Customers cannot claim to withdraw any kind of cashback by any other
            form (example - by bkash, bank or cash) except Zambet balance.
          </p>
          <p>13. Valuing, AVAILABILITY AND ORDER PROCESSING</p>
          <p>
            All costs are recorded in India Rupee ( INR) and are comprehensive
            of VAT and are recorded on the Site by the merchant that is selling
            the item or administration. Things in your Shopping Cart will
            consistently mirror the latest value shown on the thing's item
            detail page. If it's not too much trouble note that this cost may
            vary from the value appeared for the thing when you previously put
            it in your truck. Putting a thing in your truck doesn't save the
            value that appeared around then. It is additionally conceivable that
            a thing's cost may diminish between the time you place it in your
            bin and the time you buy it.
          </p>
          <p>
            We don't offer value coordinating for any things sold by any
            merchant on our Site or different sites.
          </p>
          <p>
            We are resolved to give the most exact evaluating data on the Site
            to our clients; be that as it may, blunders may at present happen,
            for example, situations when the cost of a thing isn't shown
            effectively on the Site. In that capacity, we maintain all authority
            to won't or drop any request. If a thing is mispriced, we may, at
            our own tact, either get in touch with you for guidelines or drop
            your request and advise you of such crossing out. We will reserve
            the option to can't or drop any such requests whether the request
            has been affirmed and your prepayment handled. On the off chance
            that such a retraction happens on your prepaid request, our
            approaches for the discount will apply. If it's not too much trouble
            note that Zambet has 100% right on the discount sum. Generally, the
            discount sum is determined dependent on the client followed through
            on cost in the wake of deducting any kind of markdown and delivery
            charge.
          </p>
          <p>
            We list accessibility data for items recorded on the Site,
            remembering for every item data page. Past what we state on that
            page or generally on the Site, we can't be increasingly explicit
            about accessibility. It would be ideal if you note that dispatch
            gauges are only that. They are not ensured dispatch times and ought
            not to be depended upon in that capacity. As we process your
            request, you will be educated by email or SMS if any items you
            request end up being inaccessible.
          </p>
          <p>
            It would be ideal if you note that there are situations when a
            request can't be prepared for different reasons. The Site maintains
            whatever authority is needed to won't or drop any request in any
            way, shape or form at some random time. You might be approached to
            give extra confirmation or data, including yet not constrained to
            telephone numbers and address, before we acknowledge the request.
          </p>
          <p>
            So as to keep away from any extortion with a credit or check cards,
            we maintain whatever authority is needed to acquire approval of your
            installment subtleties before furnishing you with the item and to
            confirm the individual data you imparted to us. This confirmation
            can take the state of a character, spot of habitation, or banking
            data check. The nonappearance of an answer following such a request
            will naturally cause the wiping out of the request inside a sensible
            timetable. We maintain whatever authority is needed to continue to
            coordinate undoing of a request for which we presume a danger of
            false utilization of banking instruments or different reasons
            without earlier notice or any ensuing lawful obligation.
          </p>
          <p>
            If there is any mistakes found regarding pricing (example-
            overpriced than the MRP or lower price than the MRP) of any product
            and if the seller delivers that mispriced product even after
            notified by customer and if any action is not taken by the seller
            even after notified by customer then the seller will be solely
            legally liable for this.
          </p>
          <p>14. Special Items</p>
          <p>SECURITY AND FRAUD</p>
          <ul>
            <li>
              When you utilize a voucher, you warrant to Zambet that you are the
              appropriately approved beneficiary of the voucher and that you are
              utilizing it in compliance with common decency.
            </li>
            <li>
              If you recover, endeavor to reclaim or support the recovery of
              voucher to acquire limits to which you are not entitled you might
              be perpetrating a common or criminal offense
            </li>
            <li>
              If we sensibly accept that any voucher is being utilized
              unlawfully or illicitly, we may reject or drop any voucher/request
              and you concur that you will have no case against us in regard of
              any dismissal or crossing out. Zambet maintains whatever authority
              is needed to make any further move it considers suitable in such
              occasions
            </li>
          </ul>
          <p>15. Mass Purchasing</p>
          <p>
            Zambet&nbsp;sites are accessible for non-business and residential
            utilization as it were. We maintain all authority to reject or cross
            out your request on the off chance that we trust you are requesting
            our items for business or other re-deal purposes. We apply breaking
            points to some of our items to ensure stock accessibility so that
            whatever number of our clients as could be expected under the
            circumstances can purchase our items.
          </p>
          <p>16. RESELLING Zambet PRODUCTS</p>
          <p>
            Reselling Zambet products for business purposes is strictly
            prohibited.If any unauthorized personnel are found committing the
            above act,legal action may be taken against him/her. If it is found
            and proventhat any order has been placed to cash out the paid
            amount, legalaction may be taken against him/her. If any seller
            orders (as acustomer) from their own shop using cashback or any
            other balanceit would be considered as the violation of the act
            mentioned above.In that case seller (as seller account) &amp;
            customer (as customeraccount) would be bound to oblige the decision
            taken by Zambet aswell as legal action may be taken.
          </p>
          <p>17. Stock availability</p>
          <p>
            The orders are subject to availability of stock. If there is any
            problem with stock then the order can be canceled at any time,
            irrespective of any duration.
          </p>
          <p>18. Delivery Timeline</p>
          <p>
            The delivery might take longer than usual timeframe/line to be
            followed by Zambet. The delivery timeframe is only subject to
            estimation and please consider and calculate the announced timeframe
            as working days. It might vary depending upon the circumstances.
            Delivery might be delayed due to force majeure events which include,
            but not limited to, political unrest, political event,
            national/public holidays/official holiday(s), etc.
          </p>
          <p>19. Delivery Charge(s)</p>
          <p>
            Zambet&nbsp;will bear delivery charges for the order(s) with the
            following conditions unless otherwise there is any specific campaign
            wise instruction for delivery charge.
          </p>
          <p>19.1. Weight must be no more than 10 Kgs.</p>
          <p>19.2. Size Must be within 1 cubic foot.</p>
          <p>Please note that,</p>
          <p>
            i) Fragile and/or Sensitive items (example Electronics, Home
            appliances, decorative items, crockeries etc.) may be excluded from
            the above conditions.
          </p>
          <p>
            ii) Delivery charge(s) may applicable if seller deliver the
            product(s).
          </p>
          <p>
            iii) Waiver of the delivery charge(s) may depend on different
            circumstances such as delivery area, road conditions,
            transportations cost etc.
          </p>
          <p>
            iv) liquid items, gymnasium instruments and any kind of product that
            may require special carrying facilities are excluded from the above
            condition.
          </p>
          <p>
            v) If collection or delivery of a Consignment takes place at your
            premises, we shall not be under any obligation to provide any
            equipment or labor or any associated cost(s) which, apart from the
            driver collecting the Consignment, may be required for loading or
            unloading of a Consignment. Delivery charge does not include any
            installation cost. Installation cost (if there is any) is subject to
            supplier’s policy.
          </p>
          <p>
            vi) Provision of the home delivery is/are subject to carrier and
            sellers’ delivery policy.
          </p>
          <p>
            vii) If any delivery fails due to customer negligence or any other
            reason from the customer end then the customer is bound to pay the
            return courier charge(s) as well as the redelivery charge(s).
          </p>
          <p>20. Returns Policy</p>
          <p>
            1.If your item is faulty/harmed or mistaken/deficient at the hour of
            conveyance, if you don't mind, please get in touch with us inside
            the pertinent return window. Your item might be qualified for
            discount or substitution relying upon the item class and condition.
          </p>
          <p>
            2. Please note that a few items are not qualified for arrival if the
            item is "Never again required"
          </p>
          <p>
            3. For gadget related issues after use or the lapse of the arrival
            window, we will allude you to the brand guarantee focus (if
            relevant).
          </p>
          <p>
            4. Please note that you should keep and be able to provide proper
            documentations and proof about your return/refund claim (i.e.
            unboxing video, receiving invoice, etc.).
          </p>
          <p>21. Cancellation</p>
          <p>
            Zambet&nbsp;retains unqualified right to cancel any order at its
            sole discretion prior to dispatch and for any reason which may
            include, but not limited to, the product being mispriced, out of
            stock, expired, defective, malfunctioned, and containing incorrect
            information or description arising out of technical or typographical
            error or for any other reason.
          </p>
          <p>22. Refund</p>
          <p>
            In case of any cancellations of any order(s) due to
            inevitablecircumstances the paid amount would be refunded as
            thecustomers’ Zambet account firstly. Customer need to report an
            issueas refund category and should mention his/her desired refund
            type(i.e. bkash/bank) along with details (bkash personal number,
            bankaccount details)
          </p>
        </div>
      </div>

      <a className="btn-scroll-top show" href="#top" data-scroll>
        <span className="btn-scroll-top-tooltip text-muted font-size-sm mr-2">
          Top
        </span>
        <i className="btn-scroll-top-icon czi-arrow-up"> </i>
      </a>
    </>
  );
}

export default SellerTermsAndConditions;
